import { ProgressBar } from 'react-bootstrap';
import useMultistepForm from '../../hooks/useMultistepForm';

const MultistepProgressBar = ({ form }) => {
  const { currentStep, steps, complete } = useMultistepForm(form);
  return <ProgressBar variant="primary" now={complete ? 100 : (100 / steps) * (currentStep - 1)} />;
};
export default MultistepProgressBar;
